import { Component, inject, input, model, output } from '@angular/core';
import { Button } from './../button/button';
import { Translate } from '@services/core/translate';

@Component({
  selector: 'app-input-ia-switch',
  imports: [ Button ],
  templateUrl: './input-ia-switch.html',
  styles: `
    :host {
      border-radius: var(--border-small);
      border: 1px solid var(--gray-thick-soft);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `,
})
export class InputIASwitch {
  // Servicios
  public readonly t = inject(Translate).translateFn();

  // Inputs
  $iconScale = input<number>(.8, { alias: 'iconScale' });
  $inputIAEnabled = model<boolean>(false);

  // Outputs
  $inputIAToggle = output<boolean>();
}
